import * as Yup from "yup";

const RequestOTPSchema = Yup.object().shape({
        access_code: Yup.string()
        .required('Required')
});

export default RequestOTPSchema;